import { HTTPClient } from "../common/HTTPClient";

export interface ShippopCreateCodRequestParams {
  email: string;
}

export class ShippopClient {
  constructor(private httpClient: HTTPClient) {}

  public async postShippopCod(
    params: ShippopCreateCodRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/shippops/verify-link",
      method: "POST",
      data: params
    });

    return data;
  }
}
